const GoogleAnalyticsEvents = {
    ACCEPT_OFFER_SUBMITTED: "accept offer submitted",
    DOWN_PAYMENT: "down payment",
    FULL_APPLICATION_SUBMITTED: "full application submitted",
    IFRAME: "iframe",
    NOT_INTERESTED_BUTTON: "not interested button",
    PREQUAL_SUBMITTED: "prequal submitted",
    SIDE_BY_SIDE: "side by side",
    START_BUTTON: "start button"
}

export default GoogleAnalyticsEvents
